import { reportSGM } from '@/utils/sgm'

/** 代码更新 */
export function formatPhoneNo(phone: string) {
  // 移除手机号中的非数字字符
  const digits = phone.replace(/\D/g, '')
  // 使用正则表达式匹配并插入空格
  return digits.replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
}

/** 是否禁止屏幕滚动 */
export function fixScreen(forbiden: boolean) {
  document.body.style.overflow = forbiden ? 'hidden' : 'visible'
}

/** 沉睡时间 */
export function sleep(
  time: number = 10000,
  callback?: () => void
): Promise<void> {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      clearTimeout(timer)
      resolve()
      if (typeof callback === 'function') {
        callback()
      }
    }, time)
  })
}

/** 页面滚动 */
export function toPageTop(top: number) {
  window.scrollTo({ top: top || 0, behavior: 'smooth' })
}

/** 监听页面显示隐藏 */
interface PageVisibilityOptions {
  onShow: () => void
  onHide: () => void
}
export function pageVisibleInit({
  onShow = () => {},
  onHide = () => {}
}: Partial<PageVisibilityOptions>): void {
  const hiddenProperty: string =
    'hidden' in document
      ? 'hidden'
      : 'webkitHidden' in document
        ? 'webkitHidden'
        : 'mozHidden' in document
          ? 'mozHidden'
          : ''
  const visibilityChangeEvent: string | null = hiddenProperty
    ? hiddenProperty.replace(/hidden/i, 'visibilitychange')
    : null

  if (visibilityChangeEvent) {
    document.addEventListener(visibilityChangeEvent, () => {
      if (document[hiddenProperty as keyof typeof document]) {
        onHide()
      } else {
        onShow()
      }
    })
  } else {
    reportSGM({
      code: 'pageVisibleInit_env_error'
    })
  }
}
